export const getActiveRides = async () => {
  const response = await fetch('https://admin.dabeeb.co/active-rides')
  const data = await response.json()
  if (response.status === 200) {
    return data
  } else {
    throw data
  }
}
